import React, { useEffect } from "react"
import useContentStore from "../../redux/stores/contentStore"
import useTranslator from "../useTranslator"

export default function Header() {
  const { current, pagesOrder, content, pages, language, setPage, setLanguage} = useContentStore((state) => state)
  const translate = useTranslator();
  // useEffect(() => {
  //     function changeContent(){
  //         setContent(current === "products" ? "experiences" : "products");
  //     }
  //     document.addEventListener("click", changeContent)
  //     return () => document.removeEventListener("click", changeContent);
  // }, [current]);
  const pagesLinks = pagesOrder.map(( page, i) => {
      const { title, id } = page;
      let className = "frame__link";
      let onClick = null;
      if (id === current)
          className += " active";
      else
          onClick = () => setPage(id);

      return <a className={className} onClick={onClick} key={id}>{translate(title)}</a>
  });

  return (
      <div className="frame">
          <h1 className="frame__title">
              <span className={language === "en" ? "active" : ""} onClick={() => setLanguage("en")} style={ {marginRight: "16px"} }>EN</span>
              <span className={language === "es" ? "active" : ""} onClick={() => setLanguage("es")}>ES</span>
          </h1>
         <div className="frame__links">
           {pagesLinks}
         </div>
         <div className="frame__nav">
           <a className="frame__link" href="#00" children="intro" />
           <a className="frame__link" href="#01" children="01" />
           <a className="frame__link" href="#02" children="02" />
           <a className="frame__link" href="#03" children="03" />
           <a className="frame__link" href="#04" children="04" />
           <a className="frame__link" href="#05" children="05" />
           <a className="frame__link" href="#07" children="06" />
         </div>
       </div>
  )
}
